/* Publish by EComposer at 2025-08-01 17:23:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-a6jyt3ztk0f"]=  window.__ectimmers["ecom-a6jyt3ztk0f"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-a6jyt3ztk0f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6jyt3ztk0f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxehqf3tm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxehqf3tm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf921dvr1tk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf921dvr1tk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ov2viwzu45').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ov2viwzu45', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fsfh5q8ts3e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fsfh5q8ts3e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ivoexci1gt8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ivoexci1gt8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pzss2et6ud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pzss2et6ud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0ycdtajnua').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0ycdtajnua', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-19cpsz9ytcv"]=  window.__ectimmers["ecom-19cpsz9ytcv"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-19cpsz9ytcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-19cpsz9ytcv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klw567ok1a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klw567ok1a', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q8ifdvbw1j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q8ifdvbw1j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qmq9zoo7ivf"]=  window.__ectimmers["ecom-qmq9zoo7ivf"] || {};
var e=this.$el;if(e&&this.isLive){var o=e.querySelectorAll(".element-social-link:not(.element-social-link__custom)");o.length&&o.forEach(function(s){var n=s.getAttribute("href")||"#",r=n.replace("{current-link}",location.href);s.setAttribute("href",r)})}

                    });
                    
                        document.querySelectorAll('.ecom-qmq9zoo7ivf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmq9zoo7ivf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-aw0ovj3nkh"]=  window.__ectimmers["ecom-aw0ovj3nkh"] || {};
if(this.settings.layout==="slider"){let i=this.$el,t="bullets";if(this.settings.slider_pagination_style==="progress"&&(t="progressbar"),!i)return;let o=i.querySelector(".ecom-shopify__blog-container"),s=o&&o.dataset.optionSwiper;s=JSON.parse(s),s.pagination={el:i.querySelector(".ecom-swiper-pagination"),type:t,clickable:!0},s.navigation={nextEl:i.querySelector(".ecom-swiper-button-next"),prevEl:i.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(o,s)}if(this.settings.use_ajax&&this.isLive){const i=this.$el;if(!i)return;const t=i.querySelector(".ecom-shopify__blog-wrapper"),o=function(e){e.preventDefault();const a=this.dataset.get,n=this.closest(".ecom-sections[data-section-id]");if(!a||!n||!n.dataset.sectionId)return;const p=n.dataset.sectionId,_=`${a}&section_id=${p}`;c(_,n),t.scrollIntoView()};i.querySelectorAll(".ecom-pagination-item").forEach(e=>{e.addEventListener("click",o)});const c=function(e,a){const n=async function(p){return(await fetch(p,{method:"GET",cache:"no-cache",headers:{"Content-Type":"text/html"}})).text()};a.classList.add("ecom-doing-load-blog"),n(e).then(function(p){i.querySelectorAll(".ecom-shopify__blog--post").forEach(function(u){u.remove()});const d=document.createElement("div");d.innerHTML=p;const r=d.querySelector(".ecom-shopify__blog--posts");if(!r)return;const y=a.querySelector(".ecom-shopify__blog--posts"),$=a.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");for(;r.firstChild;)y.appendChild(r.firstChild);r.parentNode.removeChild(r);const h=d.querySelector(".ecom-pagination-navigation.ecom-collection__pagination-navigation");h&&($.innerHTML=h.innerHTML,i.querySelectorAll(".ecom-pagination-item").forEach(v=>{v.addEventListener("click",o)}))}).finally(function(){a.classList.remove("ecom-doing-load-blog")})}}

                    });
                    
                        document.querySelectorAll('.ecom-aw0ovj3nkh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aw0ovj3nkh', settings: {"layout":"grid"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j0f5lzvymt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j0f5lzvymt', settings: {"layout":"grid"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}